import { useEffect, useMemo } from 'react';

import { useAppSelector } from '@/hooks';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';

import useIsBlacklisted from '@/hooks/contract/useIsBlacklisted';
import * as Sentry from '@sentry/react';
import { IUserState, selectCurrentUserAddr, selectImpostorAddress, selectUserState } from './userSlice';

export function useUserState(): IUserState {
  const userState = useAppSelector(selectUserState);
  return userState;
}

export function useUserAddrState(): string | undefined {
  // adapt cosplay mode
  const impostorAddress = useAppSelector(selectImpostorAddress) || import.meta.env.VITE_IMPOSTOR?.toLocaleLowerCase();
  const account = useAppSelector(selectCurrentUserAddr);
  return useMemo(() => {
    if (impostorAddress) return impostorAddress;
    return account;
  }, [account, impostorAddress]);
}

export const useIsBlacklistedFromStore = (): boolean | undefined => {
  const { isBlacklisted } = useIsBlacklisted();

  return isBlacklisted;
};

export const useSetSentryUser = (): void => {
  const userAddress = useUserAddr();
  const chainId = useChainId();
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development' && import.meta.env.VITE_AWS_ENV !== 'dev') {
      Sentry.setUser({ userAddress, chainId });
    }
  }, [userAddress, chainId]);
};
